import React, { useMemo } from "react";
import { Base } from "../../framework/common/base";
import { useParams } from "react-router-dom";
import { WorkHourCard } from "./WorkHourCard";
import { PlannedWorkShiftDto } from "../../models/plannedWorkShift/plannedWorkShift";
import { useShowWorkShiftEndTimesInMobile } from "../../hooks/framework/useShowWorkShiftEndTimesInMobile";

const formatTime = (time: string, date: string) =>
    Base.isSameDay(time, date)
        ? Base.dateToTimeStr(time)
        : Base.dateToDateTimeStr(time);

interface PlannedWorkShiftCardProps {
    shift: PlannedWorkShiftDto;
}

export const PlannedWorkShiftCard = ({ shift }: PlannedWorkShiftCardProps) => {
    const { date } = useParams();
    const dateString = Base.dateToDateJSON(date);
    const showEndTimes = useShowWorkShiftEndTimesInMobile();

    const {
        startTime,
        endTime,
        label,
        vehicleName,
        routeName,
        routeComment,
        comment,
    } = shift;

    const cardLabel = useMemo(
        () => {
            if (showEndTimes) {
                return `${formatTime(startTime, dateString)} - ${formatTime(
                    endTime,
                    dateString
                )} ${label || ""}`;
            } else {
                return `${formatTime(startTime, dateString)} ${label || ""}`;
            }
        },
        [startTime, endTime, dateString, label, showEndTimes]
    );

    const cardContent = useMemo(
        () => [vehicleName, comment].filter(Boolean).join(", "),
        [vehicleName, comment]
    );

    return (
        <WorkHourCard
            id={`planned-workshift-card-${shift.id}`}
            testId={`planned-workshift-card-${shift.id}`}
            label={cardLabel}
            amount={showEndTimes ? Base.dateDiffInMinutes(startTime, endTime) : 0}
            bgColor="lightBlue.main"
            content={cardContent}
            routeInfo={routeName ? { routeName, routeComment } : undefined}
        />
    );
};
